import React from 'react';
import { Check, ArrowRight, CreditCard } from 'lucide-react';
import { Section, CTAButton } from './Shared';
export function Offer() {
  return <div id="oferta" className="bg-cream" data-id="element-107">
      <Section className="max-w-4xl" data-id="element-108">
        <div className="bg-white rounded-3xl shadow-xl border border-beige-muted overflow-hidden" data-id="element-109">
          {/* Header */}
          <div className="bg-sage p-8 md:p-10 text-center" data-id="element-110">
            <p className="text-white/90 text-lg mb-4" data-id="element-111">
              Una consulta con una especialista puede costar más de $30.000...
            </p>
            <div className="flex items-center justify-center gap-3 text-white font-bold text-xl md:text-2xl" data-id="element-112">
              <ArrowRight className="w-6 h-6" data-id="element-113" />
              <p data-id="element-114">
                Acá tenés un método completo paso a paso para aplicarlo vos
                misma
              </p>
            </div>
            <p className="text-white/80 mt-4 text-base" data-id="element-115">
              Hoy podés cambiar tus noches por menos de lo que gastás en una
              salida
            </p>
          </div>

          {/* Body */}
          <div className="p-8 md:p-12 flex flex-col items-center text-center" data-id="element-116">
            {/* Price Block */}
            <div className="mb-4" data-id="element-117">
              <p className="text-charcoal-light line-through text-xl mb-2" data-id="element-118">
                Antes: $29.980
              </p>
              <div className="flex items-center justify-center gap-4" data-id="element-119">
                <span className="bg-cta/10 text-cta font-bold px-3 py-1 rounded-md text-sm uppercase tracking-wider" data-id="element-120">
                  Hoy
                </span>
                <span className="text-5xl md:text-6xl font-playfair text-charcoal font-bold" data-id="element-121">
                  $14.990
                </span>
              </div>
            </div>

            <p className="text-charcoal-light italic mb-8" data-id="element-122">
              Menos de lo que cuesta una sola consulta con una especialista
            </p>

            {/* Includes */}
            <div className="space-y-4 mb-10 text-left w-full max-w-sm mx-auto" data-id="element-123">
              <div className="flex items-center gap-3" data-id="element-124">
                <Check className="w-5 h-5 text-sage-dark" data-id="element-125" />
                <span className="text-charcoal font-medium" data-id="element-126">
                  Método completo
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-127">
                <Check className="w-5 h-5 text-sage-dark" data-id="element-128" />
                <span className="text-charcoal font-medium" data-id="element-129">
                  3 bonos incluidos
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-130">
                <Check className="w-5 h-5 text-sage-dark" data-id="element-131" />
                <span className="text-charcoal font-medium" data-id="element-132">
                  Acceso inmediato
                </span>
              </div>
            </div>

            {/* CTA */}
            <CTAButton className="w-full md:w-auto mb-3 px-10 py-5 text-lg" data-id="element-133">
              QUIERO QUE MI BEBÉ DUERMA MEJOR
            </CTAButton>

            <p className="text-sm text-charcoal-light mb-6" data-id="element-134">
              🔓 Acceso inmediato después del pago
            </p>

            {/* Payment Info */}
            <div className="flex items-center justify-center gap-2 text-charcoal-light bg-cream-dark px-6 py-3 rounded-full" data-id="element-135">
              <CreditCard className="w-5 h-5 text-sage-dark" data-id="element-136" />
              <span className="font-medium" data-id="element-137">3 cuotas sin interés</span>
              <span className="text-sm opacity-70 ml-1" data-id="element-138">con Mercado Pago</span>
            </div>
          </div>
        </div>
      </Section>
    </div>;
}